import api from '@/api'
// eslint-disable-next-line
import axios from '@/axios'
import qs from 'qs';

const path = '/CargoPersonal'

export default{

  getPersonal(obj){
    console.log('Find', obj)
    return axios.post(`${api.url + path}/Find`, obj)
},
getLista(obj){
  console.log("getLista");
  return axios.get(`${api.url + path}/GetLista`,{
    params: obj
  })
}
}



// WEBPACK FOOTER //
// ./src/services/cargopersonal/index.js